var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSwatchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 14C3.95942 14 3.28115 13.719 2.78105 13.219C2.28095 12.7189 2 12.0406 2 11.3333V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6C6.35362 2 6.69276 2.14048 6.94281 2.39052C7.19286 2.64057 7.33333 2.97971 7.33333 3.33333V11.3333C7.33333 12.0406 7.05238 12.7189 6.55229 13.219M4.66667 14C5.37391 14 6.05219 13.719 6.55229 13.219M4.66667 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V10C14 9.64638 13.8595 9.30724 13.6095 9.05719C13.3594 8.80714 13.0203 8.66667 12.6667 8.66667H11.1047M6.55229 13.219L12.2093 7.562C12.4593 7.31196 12.5997 6.97289 12.5997 6.61933C12.5997 6.26578 12.4593 5.9267 12.2093 5.67667L10.3233 3.79067C10.0733 3.54071 9.73422 3.40028 9.38067 3.40028C9.02711 3.40028 8.68804 3.54071 8.438 3.79067L7.33333 4.89533M4.66667 11.3333H4.67333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatchOutline);
export default __webpack_public_path__ + "static/media/ColorSwatchOutline.9b4cbbe0c41866f101e288f7a663c963.svg";
export { ForwardRef as ReactComponent };